 
 
import type { RouteObject } from 'react-router-dom';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute';

const apRoutes: RouteObject[] = [
  {
    path: 'AP',
    children: [
      // Dashboard
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/Finance/Ap/Main/ApDashboard')) },

      // ===== Settings =====
      { path: 'Suppliers', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Index')) },
      { path: 'SUPPLIERS/AddSupplier', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Add')) },
      { path: 'SUPPLIERS/:Id/UpdateSupplier', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Update')) },
      { path: 'SUPPLIERS/:id/BranchesSupplier', lazy: lazyRoute(() => import('../../pages/PUR/Settings/Suppliers/Branches/Index')) },

      { path: 'TypesOfExpenses', lazy: lazyRoute(() => import('../../pages/Finance/Settings/TypesOfExpenses/ExpenseCategory/Index')) },
      { path: 'PaymentTerms', lazy: lazyRoute(() => import('../../pages/Finance/Settings/PaymentTerms/Index')) },
      { path: 'Currencies', lazy: lazyRoute(() => import('../../pages/Finance/Settings/Currencies/Index')) },

      // Accounting Period (needs prop)
      {
        path: 'AccountingPeriod',
        lazy: lazyRouteWithProps(
          () => import('../../pages/Finance/Settings/AccountingPeriod/Index'),
          () => ({ customProp: 'Ap' as const })
        )
      },

      // ===== AP Invoices =====
      { path: 'ApInvoices', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApInvoices/Index')) },
      { path: 'ApInvoices/AddApInvoices/:referenceId?', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApInvoices/AddApInvoice')) },
      { path: 'ApInvoices/:IdInvoices/UpdateApInvoices', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApInvoices/UpdateApInvoice')) },
      { path: 'CreateAccountApInvoices', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApInvoices/CreateAccount/ListApInvoices')) },

      // ===== AP Payments =====
      { path: 'ApPayments', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApPayments/Index')) },
      { path: 'ApPayments/AddApPayments', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApPayments/Add/Add')) },
      { path: 'ApPayments/:paymentId/UpdateApPayments', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApPayments/Update/Update')) },
      { path: 'CreateAccountApPayments', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApPayments/CreateAccount/ListApPayments')) },

      // ===== AP Expense =====
      { path: 'ApExpense', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApExpense/Index')) },
      { path: 'ApExpense/AddApExpense', lazy: lazyRoute(() => import('@pages/Finance/Ap/ApExpense/ApExpenseForm')) },
      {
        path: 'ApExpense/:id/UpdateApExpense',
        lazy: lazyRouteWithProps(
          () => import('@pages/Finance/Ap/ApExpense/ApExpenseForm'),
          () => ({ isEdit: true })
        )
      },

      // ===== Invoice Payments =====
      { path: 'InvoicePayments', lazy: lazyRoute(() => import('../../pages/Finance/Ap/InvoicePayments/Index')) },
      { path: 'InvoicePayments/:invoicesId/ViewInvoice', lazy: lazyRoute(() => import('../../pages/Finance/Ap/InvoicePayments/ViewInvoice/ViewInvoice')) },

      // ===== Reports =====
      { path: 'ApReports', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApReports/ApReports')) },
      { path: 'ApReports/:ReportId/ReportsBuilder', lazy: lazyRoute(() => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')) },

      // ===== Dashboards =====
      { path: 'ApDashboards', lazy: lazyRoute(() => import('../../pages/Finance/Ap/ApDashboards/ApDashboards')) },
      { path: 'ApDashboards/:dashboardId/BuilderDashboard', lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard')) }
    ]
  }
];

export default apRoutes;
